/* eslint-disable react/no-array-index-key */
import * as React from "react";
import usePagination from "@mui/material/usePagination";
import { styled } from "@mui/material/styles";

const PaginationContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
`;

const List = styled("ul")`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`;

const PaginationButton = styled("button")<{ selected: boolean }>`
  width: 40px;
  height: 40px;
  gap: 4px;
  border-radius: 8px;
  opacity: 0px;
  margin: 0 4px;
  //styleName: Text sm/Medium;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  background-color: ${(props) => (props.selected ? "#EDF2FF" : "transparent")};
  color: ${(props) => (props.selected ? "#3B82F6" : "#6B7280")};
  cursor: pointer;
  &:hover {
    background-color: ${(props) => (props.selected ? "#E0E7FF" : "#F9FAFB")};
  }
`;

const NavButton = styled("button")`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  width: Hug (112px) px;
  height: Hug (36px) px;
  padding: 8px 14px 8px 14px;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  opacity: 0px;
  background: #ffffff;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background-color: #f9fafb;
  }
`;

const Ellipsis = styled("span")`
  padding: 6px 12px;
  color: #6b7280;
`;

interface PaginationProps {
  count: number;
  page: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    page: number
  ) => void;
}

export default function CustomPagination({
  count,
  page,
  onPageChange,
}: PaginationProps) {
  const { items } = usePagination({
    count,
    page,
  });

  return (
    <PaginationContainer>
      <div style={{ flex: "0 0 auto" }}>
        {items.some((item) => item.type === "previous") && (
          <NavButton
            disabled={page === 1}
            type="button"
            onClick={(e) => onPageChange(e, page - 1)}
          >
            ← Anterior
          </NavButton>
        )}
      </div>
      <List>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null;

          if (type === "start-ellipsis" || type === "end-ellipsis") {
            children = <Ellipsis key={index}>…</Ellipsis>;
          } else if (type === "page") {
            children = (
              <PaginationButton
                type="button"
                selected={selected}
                {...item}
                onClick={(e) => onPageChange(e, page!)}
                key={index}
              >
                {page}
              </PaginationButton>
            );
          }

          return children ? <li key={index}>{children}</li> : null;
        })}
      </List>
      <div style={{ flex: "0 0 auto" }}>
        {items.some((item) => item.type === "next") && (
          <NavButton
            disabled={page === count}
            type="button"
            onClick={(e) => onPageChange(e, page + 1)}
          >
            Próxima →
          </NavButton>
        )}
      </div>
    </PaginationContainer>
  );
}
